<template>
    <div class="card-data" :class="!sm ? 'md' : ''" id="pie">
        <Tooltip
            v-show="tip"
            :tip="tip" />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <small v-if="sub">{{sub}}</small>
            <div style="height: 29px" v-else></div>
        </div>
        
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- comentar para sacar mensaje -->
        <div v-else-if="(loader&&detailed.length==0)||(detailed[0]+detailed[1]==0)">
            <EmptyStateChart
            />
        </div>
        
        <div v-else-if="loader" style="text-align: center">
            <div style="position: relative">
                <apexchart class="chart" type="pie" :options="chartOptions" :series="detailed"></apexchart>
            </div>
            <div class="amount-holder">
                <div class="detailed-amount" v-for="(group, key) in detailed" :key="key">
                    <h4 class="amount">
                        <ICountUp
                            :endVal="percentage(group)"
                            :options="options"
                            /> %
                    </h4>
                    <p class="amount-group">{{detailedNames[key]}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'


export default {
    name: 'GraphCard',
    components: {
        ICountUp,
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: false
        },
        detailed: {
            type: Array,
            required: false
        },
        detailedNames: {
            type: Array,
            required: false
        },
        tip: {
            type: String,
            required: false
        },
        sm: {
            type: Boolean,
            required: false
        },
        loader: {
            type: Boolean,
            required: true
        },
        size: {
            type: String,
            default: "250"
        },
        total: {
            required: false,
            type: Number
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        }
    },
    data: function(){
        return {
            per: 0,
            tooltip: false,
            options: {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            }
        }
    },
    methods: {
        closeTip: function(){
            if (this.tooltip){
                this.tooltip = false;
            }
        },
        percentage: function(item){
            let total = 0
            _.each(this.detailed, (value, index) => {
                total = total + value
            })
            if (total == 0) {
                total = 1
            }
            return (item * 100) / total
        }
    },
    computed: {
        chartOptions: function() {
            return {    
                chart: {
                    type: 'pie',
                    animations: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    enabled: false
                },
                labels: this.detailedNames,
                colors: ["#720acb", "#f1840a"],
                legend: {
                    offsetX: 0,
                    offsetY: 40,
                    position: 'right',
                    horizontalAlign: 'center',
                    markers: {
                        width: 12,
                        height: 12,
                        strokeWidth: 0,
                        radius: 3,
                        offsetX: -4,
                        offsetY: 0
                    },
                }
            }
        },
    },
    directives: {
        clickoutside: {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
                };
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
            stopProp(event) { event.stopPropagation() }
        }
    }
}
</script>

<style lang="sass">
.card-data.lg-row 
    grid-row-end: span 2
.card-data .chart
    margin: 5px auto
    display:block
    width: 95%
    @include tablet-landscape
        height: 80%
.amount-holder
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    .detailed-amount 
        display: flex
        margin: 0 8px
        flex-direction: column
        flex-grow: 1
        .amount
            font-family: $title-font
            font-size: 24px
            font-weight: 600
            text-align: center
            color: #302f2f
        .amount-group 
            font-family: $body-font
            font-size: 12px
            font-weight: 300
            text-align: center
            color: #302f2f
            margin-bottom: 14px

</style>